// src/app/worker-types/constants/worker-type-import-headers.const.ts
export const WORKER_TYPE_IMPORT_HEADERS = ['Name', 'Description'] as const;

export type WorkerTypeImportHeader = (typeof WORKER_TYPE_IMPORT_HEADERS)[number];